export enum BullhornDataSpecialisationTypes {
  COLOR = 'COLOR',
  DATE = 'DATE',
  TIME = 'TIME',
  DATETIME = 'DATETIME',
  FLOAT = 'FLOAT',
  INTEGER = 'INTEGER',
  MONEY = 'MONEY',
  NUMERIC = 'NUMERIC',
  PERCENTAGE = 'PERCENTAGE',
  PHONE = 'PHONE',
  SSN = 'SSN',
  HTML = 'HTML',
}
